import { defineMessages } from 'react-intl';

const messages = defineMessages({
    orderCanceledPretext: {
        id: 'CancelationReasons.orderCanceledPretext',
        defaultMessage: 'Feedback from the restaurant',
    },
    CLOSING_SOON: {
        id: 'CancelationReasons.CLOSING_SOON',
        defaultMessage: 'The restaurant will close soon.',
    },
    NOT_AVAILABLE_ANYMORE: {
        id: 'CancelationReasons.NOT_AVAILABLE_ANYMORE',
        defaultMessage: 'The chosen items are not available anymore.',
    },
    INVALID_COMMENTS: {
        id: 'CancelationReasons.INVALID_COMMENTS',
        defaultMessage: 'Your order comments cannot be processed.',
    },
});

export default messages;
